import * as React from "react";
const Menu = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Swap me">
      <path
        id="Vector"
        d="M12 7C12.2967 7 12.5867 6.91203 12.8334 6.74721C13.08 6.58238 13.2723 6.34811 13.3858 6.07403C13.4994 5.79994 13.5291 5.49834 13.4712 5.20737C13.4133 4.91639 13.2704 4.64912 13.0607 4.43934C12.8509 4.22956 12.5836 4.0867 12.2926 4.02882C12.0017 3.97094 11.7001 4.00065 11.426 4.11418C11.1519 4.22771 10.9176 4.41997 10.7528 4.66665C10.588 4.91332 10.5 5.20333 10.5 5.5C10.5 5.89783 10.658 6.27936 10.9393 6.56066C11.2206 6.84197 11.6022 7 12 7ZM12 17C11.7033 17 11.4133 17.088 11.1666 17.2528C10.92 17.4176 10.7277 17.6519 10.6142 17.926C10.5006 18.2001 10.4709 18.5017 10.5288 18.7926C10.5867 19.0836 10.7296 19.3509 10.9393 19.5607C11.1491 19.7704 11.4164 19.9133 11.7074 19.9712C11.9983 20.0291 12.2999 19.9994 12.574 19.8858C12.8481 19.7723 13.0824 19.58 13.2472 19.3334C13.412 19.0867 13.5 18.7967 13.5 18.5C13.5 18.1022 13.342 17.7206 13.0607 17.4393C12.7794 17.158 12.3978 17 12 17ZM12 10.5C11.7033 10.5 11.4133 10.588 11.1666 10.7528C10.92 10.9176 10.7277 11.1519 10.6142 11.426C10.5006 11.7001 10.4709 12.0017 10.5288 12.2926C10.5867 12.5836 10.7296 12.8509 10.9393 13.0607C11.1491 13.2704 11.4164 13.4133 11.7074 13.4712C11.9983 13.5291 12.2999 13.4994 12.574 13.3858C12.8481 13.2723 13.0824 13.08 13.2472 12.8334C13.412 12.5867 13.5 12.2967 13.5 12C13.5 11.6022 13.342 11.2206 13.0607 10.9393C12.7794 10.658 12.3978 10.5 12 10.5Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export { Menu };
